<template>
	<div class="content">
		<div v-for="image in model">
    		<div class="modal-dialog bg-light margin-7 radius-5">
    			<div id="banner">
			    <div v-if="image.image_url.length" class="banner-image radius-5" :style="{'background-image': 'url(' + image.image_url + ')', 'background-size': 'contain'}"></div>
			    <div class="full-width align-hor center-hor" v-else>
			      <div class="wrapper animate radius-5 banner-image full-width"></div>
			    </div>
			  </div>
    		</div>
	    </div>
	</div>
</template>
<script>
	export default {
		data() {
	        return {images: [] };
	    },
	    props: {
	      model: Array
	    },
	    created() {
	        
	    },
	    methods: {
	        
	    }
	}
</script>
<style>
	#banner {
		height: auto;
		padding: 7px;
	}
	.banner-image {
		height: 160px;
		width: 100%;
	}
	#content{
		height: auto;
		padding: 20px;
		margin-left: 230px;
		margin-right: 20px;
		padding-bottom: 30px;
		overflow: auto;
	}
</style>